import React, { useState, useEffect } from 'react';
import { FC } from 'react';
import { loading } from '../../assets/icons';
import { fetchBase64Image } from '../../utils/helpers/fetchBase64profilePhoto';

type AsyncImagePropTypes = {
    link: string;
    props?: any;
    alt?: string;
    addClassName?: string;
}

const AsyncImage: FC<AsyncImagePropTypes> = ({ link, props, alt = "img", addClassName = '' }) => {
    const [src, setSrc] = useState<any>(null);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (link) {
            setSrc(loading);
            setIsLoading(true);
            fetchBase64Image(link).then(res => {
                setSrc(res || null);
                setIsLoading(false);
            });
        }
    }, [link]);

    return src ? (
        <img src={src} alt={alt} {...props} style={{ opacity: isLoading ? .1 : 1 }} className={addClassName} />
    ) : (
        <></>
    );
};

export default AsyncImage;